var map = {
	"../pages/add-album/add-album.module": [
		405,
		6
	],
	"../pages/add-joke/add-joke.module": [
		406,
		5
	],
	"../pages/add-partner/add-partner.module": [
		407,
		24
	],
	"../pages/add-poem/add-poem.module": [
		408,
		4
	],
	"../pages/add-program/add-program.module": [
		409,
		23
	],
	"../pages/add-proverb/add-proverb.module": [
		410,
		22
	],
	"../pages/add-request/add-request.module": [
		412,
		21
	],
	"../pages/add-song/add-song.module": [
		411,
		3
	],
	"../pages/add-team-member/add-team-member.module": [
		413,
		20
	],
	"../pages/add-word/add-word.module": [
		414,
		19
	],
	"../pages/add-writer/add-writer.module": [
		416,
		18
	],
	"../pages/albums/albums.module": [
		415,
		17
	],
	"../pages/dictionary/dictionary.module": [
		417,
		2
	],
	"../pages/jokes/jokes.module": [
		418,
		1
	],
	"../pages/partners/partners.module": [
		419,
		16
	],
	"../pages/poem/poem.module": [
		421,
		15
	],
	"../pages/poems/poems.module": [
		420,
		14
	],
	"../pages/programs/programs.module": [
		422,
		13
	],
	"../pages/proverbs/proverbs.module": [
		423,
		0
	],
	"../pages/requests/requests.module": [
		425,
		12
	],
	"../pages/song/song.module": [
		424,
		11
	],
	"../pages/songs/songs.module": [
		426,
		10
	],
	"../pages/team/team.module": [
		428,
		9
	],
	"../pages/welcome/welcome.module": [
		427,
		8
	],
	"../pages/writers/writers.module": [
		429,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 195;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 195
// module chunks = 25